<template>
  <div class="container-displayerHeader">
    <div class="header-left">
      <div @click="panelchange">
        <i :class="itemsLeft.icon"></i>
        <span>{{ itemsLeft.title }}</span>
      </div>
    </div>
    <div class="header-right">

      <ul style="list-style: none">
        <li>
          <div class="title" v-if="isLogIn" id="nickname">
            <span class="nickname" @click="skip('myProject')">Hi! {{ userStore.nickname }}</span>
          </div>
        </li>
        <li>
          <div class="title" v-if="isLogIn" id="userImg_container">
            <img :src="userStore.imgurl" id="userImg" onerror="this.style.display='none'">
          </div>
        </li>
        <li v-for="(item, index) in itemsRight" :key="index" v-show="item.show">
          <div @click="skip(item.name)" class="title">
            <!-- <div :id="item.name"> -->
            <div :class="item.name !== 'home' ? 'register' : ''">{{ item.title }}</div>
            <!-- </div> -->
          </div>
        </li>
        <li>
          <div @click="logout" class="title">退出</div>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: "DisplayHeader",
};
</script>

<script setup>
// vue3的全局事件总线mitt
import emitter from "../utils/event-bus.js";
import { ref, reactive, computed, onBeforeMount } from "vue";
// import axios from "axios";
// import Toast from "@/utils/toast";
import { useUserStore } from '@/store/user';
// import { storeToRefs } from "pinia";
import { _checkAccessToken, _logout } from '@/api/index';
import wxLogin from '../utils/wxLogin.js';
// vue3中使用vue-router
import { useRouter } from "vue-router";


// 0初始化变量
const router = useRouter();

let flag = ref(true);
let itemsLeft = reactive({ title: "收起", icon: "iconfont icon-menuFold" });
let itemsRight = reactive([
  { title: "首页", name: "home", show: true },
  { title: "免费注册/登录", name: "login", show: true },
  { title: "免注册登录", name: "wxLogin", show: true },
]);



// 1判断是否是微信浏览器
const isWechatBrowser = (function () {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('micromessenger');
})()

//2 获取参数
const params = getURLParams();
if (Object.keys(params).length !== 0) {
  console.log(params.name)
  if (params.openid !== undefined && params.openid !== null && params.openid !== '') {
    localStorage.setItem('openid', params.openid)
    // console.log(localStorage.getItem('openid'))
  }
}

//0 获取CSRF_TOKEN
// function getCsrfToken() {
//   if (!localStorage.getItem("csrf_token")) {
//     axios.get(URL + 'token/').then(res => {
//       localStorage.setItem('csrf_token', res.data.csrf_token)
//     }).catch((res) => {
//       console.log("服务器错误")
//     })
//   }
// }
// getCsrfToken();      暂时不用

//4 获取用户信息
let userStore = useUserStore();
userStore.getInfo();
let isLogIn = false;


// 5 是否登录
check();



function check() {
  // userStore.getInfo();
  let access_token = userStore.access_token;
  // let { access_token } = storeToRefs(userStore);
  isLogIn = computed(() => userStore.nickname === '' || userStore.nickname === null || userStore.nickname === undefined ? false : true);
  // console.log(userStore.nickname, useUserStore.access_token)
  if (access_token !== '' && access_token !== null && access_token !== undefined) {
    _checkAccessToken(access_token)
      .then(res => {
        if (res.data.code !== 200) {
          userStore.removeInfo();
          wxLogin(isWechatBrowser, userStore);
        }
      })
      .catch(() => {
        userStore.removeInfo();
      })
  } else {
    // if (isWechatBrowser) {
    //   _wxLogin({ scene: get_wxscene() }).then((res) => {
    //     if (res.data.message === 'ok') {
    //       // 登录成功
    //       userStore.setInfo(
    //         res.data.data.access_token,
    //         res.data.data.nickname,
    //         res.data.data.id,
    //         res.data.data.imgurl
    //       );


    //       // router.push({ name: "home" });
    //     }
    //   }).catch((err) => {
    //     console.log(err);
    //   });
    // } else {
    userStore.removeInfo();
    wxLogin(isWechatBrowser, userStore);
    // }
  }
}







// 3判断是否是微信浏览器，显示不同的按钮，不同处理逻辑
onBeforeMount(() => {
  if (isWechatBrowser) {
    itemsRight[1].show = false;
    itemsRight[2].show = true;
  } else {
    itemsRight[1].show = true;
    itemsRight[2].show = false;
  }
})






// 公共函数~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~`~~~~~~~~~~~~~~~~~~
const panelchange = () => {
  flag.value = !flag.value;
  if (flag.value) {
    itemsLeft.title = "收起";
    itemsLeft.icon = "iconfont icon-menuFold";
    emitter.emit("show-panel");
  } else {
    itemsLeft.title = "展开";
    itemsLeft.icon = "iconfont icon-menuUnfold";
    emitter.emit("hide-panel");
  }
};

function skip(name) {
  router.push({ name: name, params: { type: name } });
  // router.push({ name: 'wxLoginRegister', params: { type: name } });
}

function logout() {
  let data = { 'nickname': userStore.nickname }
  userStore.removeInfo();
  _logout(data).then(() => {
    router.push({ name: "home" });
  })
    .catch((err) => { });
}

function getURLParams() {
  if (window.location.search.length === 0) {
    return {};
  }
  const searchParams = window.location.search.substring(1).split('&');
  const params = {};

  for (const param of searchParams) {
    const [key, value] = param.split('=');
    params[key] = value;
  }

  return params;
}

// function wxLogin() {

//   if (!isWechatBrowser) {
//     return;
//   }

//   let openid = localStorage.getItem('openid');
//   if (openid === null || openid === undefined || openid === '') {
//     console.log('未获取到openid')
//     return;
//   }

//   _wxLogin({ openid: openid }).then((res) => {
//     if (res.data.message === 'ok') {
//       // 登录成功
//       userStore.setInfo(
//         res.data.data.access_token,
//         res.data.data.nickname,
//         res.data.data.id,
//         res.data.data.imgurl
//       );
//     }
//   }).catch((err) => {
//     console.log(err);
//   });
// }
</script>

<style scoped>
/* 整体的样式： */
.container-displayerHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  height: 60px;
  background-color: var(--secondary-color);
  color: var(--font-color);
  min-width: 600px;
}


.header-left .title,
.header-right .title {
  height: 60px;
  box-sizing: border-box;
  font-size: 16px;
  line-height: 60px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  justify-items: center;

}

/* 左边的样式： */
i {
  height: 55px;
  font-size: 20px;
  margin-right: 5px;
  margin-left: 15px;

}

/* 右边的样式： */
.header-right {
  padding-right: 20px;
}

.header-right .title {
  padding-right: 20px;
}

.header-right .register {
  margin-top: 15px;
  height: 50%;
  border-radius: 10px;
  background-color: rgb(29, 210, 210);
  padding: 0px 10px;
  line-height: 30px;
  font-weight: 600;
}

.header-right #userImg_container {
  width: 30px;
  height: 60px;
  display: flex;
  padding-top: 50%;
  border: none;
}

.header-right #userImg {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}


.header-right li {
  float: left;
}
</style>
